<template>
  <TemplateModal
    ref="modal"
    center
    :modal-type="item.id ? 'edit' : 'create'"
    :text="text"
    :send-function="saveData"
    :disabled="disabled"
  >
    <div class="wrap">
      <template v-for="(field, f) in fields">
        <BaseInput
          v-if="field.field"
          :key="f"
          :label="field.text"
          v-model="item[field.field]"
          :rules="['required']"
          :input-type="field.field === 'percent' || field.field === 'code' || field.field === 'days' ? 'Number' : null"
        />
      </template>
    </div>
  </TemplateModal>
</template>

<script>
export default {
  name: "SettingFinanceModal",
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    text: {
      type: Object,
      default: () => {
        return {title: {}}
      }
    },
    edit: Boolean,
    fields: {
      type: Array,
      default: () => {
        return []
      }
    },
    saveFunction: {},
    disabled: Boolean,
  },
  data: () => ({
    item: {}
  }),
  created() {
    this.item = Object.assign(this.item, this.data)
  },
  methods: {
    saveData() {
      if (this.$refs.modal.validate())
        if (this.saveFunction) this.saveFunction(this.item)
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>